import Cookies from 'js-cookie';

interface TokenData {
  token: string;
  refreshToken: string;
}

// Proper cookie configuration
const getCookieOptions = () => ({
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict' as const,
  path: '/'
});

// Set tokens with proper cookie configuration
export const setAuthTokens = (tokenData: TokenData): void => {
  const cookieOptions = getCookieOptions();

  if (tokenData?.token) {
    Cookies.set('accessToken', tokenData?.token, cookieOptions);
  }
  if (tokenData?.refreshToken) {
    Cookies.set('refreshToken', tokenData?.refreshToken, cookieOptions);
  }
};

// Set user data with proper cookie configuration
export const setUserData = (userId?: string): void => {
  const cookieOptions = getCookieOptions();

  if (userId) {
    Cookies.set('userId', userId, cookieOptions);
  }
};

// Clear all auth cookies
export const clearAuthCookies = (): void => {
  Cookies.remove('accessToken');
  Cookies.remove('refreshToken');
  Cookies.remove('userId');
};

// Simple token validation utility (for client-side checks if needed)
export const isTokenExpired = (token: string): boolean => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return true;

    const payload = JSON.parse(atob(parts[1]));
    const currentTime = Math.floor(Date.now() / 1000);

    return !payload.exp || payload.exp <= currentTime;
  } catch {
    return true;
  }
};

// Get auth status from cookies
export const getAuthStatus = () => {
  const token = Cookies.get('accessToken');
  const refreshToken = Cookies.get('refreshToken');

  return {
    hasToken: !!token,
    hasRefreshToken: !!refreshToken,
    isTokenExpired: token ? isTokenExpired(token) : true
  };
};
